import React, { Component } from 'react';
import $ from "jquery";

import "./../styles/formTextItem.css";
import pdf1 from "../PDF/ATENCIÓN DE LAS URGENCIAS EN SALUD MENTAL. Ministerio de Salud y Desarrollo Social de la Nación. 2019.pdf";
import pdf2 from "../PDF/DISPOSITIVOS DE ATENCIÓN DE SALUD MENTAL...GENERAL PUEYRREDON. Mesa Intersectorial de Salud Mental Comunitaria Mar del Plata. 2017.pdf"

export default class PagMasInfo extends Component {
    componentDidMount(){
        $(".seccion h3").click(function(){
            if($(this).siblings(".secContenido").height() > 0){
                $(this).siblings(".secContenido").animate({"height": "0px"}, {
                    easing: "linear",
                    duration: "150"
                });
            }
            else{
                const elementHeight = $(this).siblings(".secContenido").css({"height": "auto"}).height();
                $(this).siblings(".secContenido").css({"height": "0"});
                $(this).siblings(".secContenido").animate({"height": elementHeight + "px"}, {
                    easing: "linear",
                    duration: "100",
                    complete: () => {
                        //setTimeout(()=>{$(this).siblings(".secContenido").css({"height": "auto"})}, 1000);
                        $(this).siblings(".secContenido").css({"height": "auto"})
                    }
                });
            }
            $(this).toggleClass("icon-plus");
            $(this).toggleClass("icon-minus");
        });
        $(".seccion h4").click(function(){
            if($(this).siblings(".secContenido").height() > 0){
                $(this).siblings(".secContenido").animate({"height": "0px"}, {
                    easing: "linear",
                    duration: "100",
                    complete: () => {
                        $(this).siblings(".secContenido").css({"marginTop": "0px"})
                    }
                });
            }
            else{
                const elementHeight = $(this).siblings(".secContenido").css({"height": "auto"}).height();
                $(this).siblings(".secContenido").css({"height": "0"});
                $(this).siblings(".secContenido").css({"marginTop": "15px"})
                $(this).siblings(".secContenido").animate({"height": elementHeight + "px"}, {
                    easing: "linear",
                    duration: "100",
                    complete: () => {
                        //setTimeout(()=>{$(this).siblings(".secContenido").css({"height": "auto"})}, 1000);
                        $(this).siblings(".secContenido").css({"height": "auto"})
                    }
                });
            }
            $(this).toggleClass("icon-plus");
            $(this).toggleClass("icon-minus");
        });
        
    }

    render() {
        return (
            <React.Fragment>
                <div className="card formTextItem">
                    <h1>Mitos sobre el suicidio</h1>
                    <p className="description">
                        Existen una serie de creencias erróneas, equivocadas, sobre el suicidio y las personas que lo 
                        padecen, que se trasmiten como “verdades” pero que no poseen veracidad científica. Estas 
                        creencias, denominadas mitos, impactan directamente obstaculizando las acciones de prevención, 
                        detección e intervención que se podrían realizar tanto desde la sociedad en general, como los 
                        profesionales de la salud, docentes, etc. Por ello, es fundamental erradicarlos y la mejor 
                        manera es a través de información basada en los hallazgos científicos de la suicidología.
                    </p>
                    <div className="seccion">
                        <h4 className="icon-plus"><b>Preguntar a una persona si está pensando en suicidarse, puede incitarle a hacerlo.</b></h4>
                        <div className="secContenido">
                            <p>
                                Está demostrado que preguntar y hablar con la persona sobre la presencia de pensamientos suicidas, 
                                disminuye el riesgo de cometer el acto. Hablar siempre genera alivio en la persona que está sufriendo.<br/> 
                                Es muy importante acercarse con una actitud de comprensión y de escucha, para que sienta tu deseo de 
                                ayudar y tu preocupación. No intentes discutir o minimizar estas ideas. Dejalx hablar de lo que le pasa.

                            </p>
                        </div>
                    </div>
                    <div className="seccion">
                        <h4 className="icon-plus"><b>La persona que expresa su deseo de acabar con su vida nunca lo hará.</b></h4>
                        <div className="secContenido">
                            <p>
                                La gran mayoría de los casos en que las personas han intentado suicidarse, habían manifestado 
                                de alguna manera su intención de hacerlo con palabras, amenazas, gestos o cambios de conducta.<br/>
                                Estas verbalizaciones o gestos SIEMPRE indican que esa persona está sufriendo, necesita ayuda y 
                                no sabe cómo pedirla. Es muy importante que NUNCA sean consideradas como un simple llamado de 
                                atención, chantaje o manipulación de la persona para la obtención de un fin determinado.
                            </p>
                            
                        </div>
                    </div>
                    <div className="seccion">
                        <h4 className="icon-plus"><b>La persona que se quiere suicidar no lo dice.</b></h4>
                        <div className="secContenido">
                            <p>
                                Solamente un pequeño número de suicidios se produce sin aviso. De cada 10 personas que se 
                                suicidan, 9 lo expresaron claramente o dejaron entrever sus intenciones de acabar con su vida.<br/> 
                                Todas las amenazas de autolesión deben ser tomadas en serio. Por eso, si detectás una señal 
                                de alerta directa o indirecta y creés que  la persona que te preocupa se encuentra en una 
                                situación de riesgo, es importante que le preguntes sobre ello.
                            </p>
                            
                        </div>
                    </div>
                    <div className="seccion">
                        <h4 className="icon-plus"><b>El suicidio es impulsivo y la mayoría de los suicidas no avisa.</b></h4>
                        <div className="secContenido">
                            <p>
                                El suicidio puede ser el resultado de un acto impulsivo repentino o de una planificación 
                                muy cuidadosa. En ambos casos, casi siempre existen señales directas o indirectas, mensajes, 
                                gestos que advierten el riesgo de un intento de suicidio.<br/>
                                Es erróneo pensar que no podemos hacer nada para prevenir la conducta suicida. El suicidio 
                                y/o sus intentos, en muchas ocasiones, se pueden prevenir y es por ello muy importante que 
                                aprendamos a detectar las señales de alerta de riesgo.
                            </p>
                            
                        </div>
                    </div>
                    <div className="seccion">
                        <h4 className="icon-plus"><b>Solo las personas con problemas graves se suicidan.</b></h4>
                        <div className="secContenido">
                            <p>
                                El suicidio es multicausal. Muchos problemas pequeños pueden llevar al suicidio. 
                                Nunca menosprecies ni compares. Lo que para algunos puede ser un problema simple 
                                o sin importancia, para otros  puede ser algo catastrófico.
                            </p>
                            
                        </div>
                    </div>
                    <div className="seccion">
                        <h4 className="icon-plus"><b>Los suicidas sólo desean morir y nadie puede sacarles esa idea.</b></h4>
                        <div className="secContenido">
                            <p>
                                Es muy frecuente que presenten sentimientos ambivalentes al respecto. Es decir deseos de 
                                vivir y morir a la vez, temor a la muerte, mínima esperanza de que algo cambie. Por eso 
                                siempre hay que acercarse a alguien que está en crisis para ofrecer ayuda. 
                            </p>
                            
                        </div>
                    </div>
                    <div className="seccion">
                        <h4 className="icon-plus"><b>La mejoría inmediata después de una crisis suicida significa que salió del riesgo.</b></h4>
                        <div className="secContenido">
                            <p>
                                Casi la mitad de las personas que atravesaron una crisis suicida o cometen suicidio, 
                                lo llevaron a cabo dentro de los tres primeros meses donde se creía que la crisis había 
                                pasado. Cuando tras un periodo de crisis en el que ocurrió algún evento desencadenante 
                                (por ej. la muerte de un ser querido), la persona muestra de repente una mejoría, esto puede 
                                indicar que ha elaborado un plan para quitarse la vida. Puede ser un momento de riesgo inminente. 
                            </p>
                            
                        </div>
                    </div>
                    <div className="seccion">
                        <h4 className="icon-plus"><b>Las personas con conductas autodestructivas solamente lo hacen para llamar la atención. </b></h4>
                        <div className="secContenido">
                            <p>
                                Todo comportamiento autodestructivo es grave y puede ser letal, por lo que debe tomárselo 
                                muy seriamente y brindarle ayuda profesional. Nunca debe desestimarse. Se trata de una 
                                persona que está sufriendo y necesita ayuda.
                            </p>
                            
                        </div>
                    </div>
                    <div className="seccion">
                        <h4 className="icon-plus"><b>El suicidio se hereda.</b></h4>
                        <div className="secContenido">
                            <p>
                                No se hereda, puede que se imite un comportamiento o que se herede la predisposición a 
                                desarrollar algún padecimiento en el que el suicidio pueda ocurrir, como esquizofrenia y
                                la bipolaridad. 
                            </p>
                        </div>
                    </div>
                </div>
                <div className="card formTextItem">
                    <h1 className="noDescription">Factores protectores, de riesgo y precipitantes</h1>
                    <div className="seccion">
                        <h4 className="icon-plus"><b>Factores Protectores</b></h4>
                        <div className="secContenido">
                            <ul>
                                <li>Buena autoestima</li>
                                <li>Percepción de contar con una red social de apoyo</li>
                                <li>Buena comunicación familiar</li>
                                <li>Sentimiento de pertenencia</li>
                                <li>Buena regulación emocional</li>
                                <li>Sensación de autocontrol</li>
                                <li>Capacidad para la resolución de problemas</li>
                                <li>Perspectiva optimista respecto del futuro</li>
                                <li>Flexibilidad</li>
                            </ul>
                        </div>
                    </div>
                    <div className="seccion">
                        <h4 className="icon-plus"><b>Factores de Riesgo</b></h4>
                        <div className="secContenido">
                            <ul>
                                <li>Baja autoestima</li>
                                <li>Sentimientos de soledad y aislamiento, de estar atrapado</li>
                                <li>Percepción de ser una carga para los demás</li>
                                <li>Dificultades en la regulación emocional</li>
                                <li>Impulsividad</li>
                                <li>Dificultades en la resolución de problemas</li>
                                <li>Percepción de falta de apoyo social</li>
                                <li>Perspectiva pesimista respecto del futuro</li>
                                <li>Autolesiones no suicidas</li>
                                <li>Presencia de cuadro psicopatológico (en especial: 
                                    depresión mayor, trastorno bipolar, esquizofrenia, 
                                    trastorno límite de personalidad)
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="seccion">
                        <h4 className="icon-plus"><b>Factores Precipitantes</b></h4>
                        <div className="secContenido">
                            <p>Presencia de algún o varios eventos vitales significativos que pueden desencadenar una crisis:
                                <div className="seccion">
                                    <h4 className="icon-plus"><b>Comunes a todas las edades</b></h4>
                                    <div className="secContenido">
                                        <ul>
                                            <li>Accidentes o diagnóstico, empeoramiento o crisis de enfermedades graves, incapacitantes o dolorosas. Propias o ajenas.</li>
                                            <li>Desastres naturales.</li>
                                            <li>Pérdida de seres queridos (incluidos animales de compañía).</li>
                                            <li>Existencia de entorno suicida: fácil acceso a medios letales, epidemias suicidas, suicidio de familiares o personas 
                                                cercanas, acceso a información y relaciones inadecuadas en medios de información, comunicación y redes sociales etc.</li>
                                            <li>Experiencias y vivencias traumáticas: agresiones y malos tratos, acosos y humillaciones, abusos sexuales, etc.</li>
                                            <li>Aumento o consumo de sustancias tóxicas.</li>
                                            <li>Estado de embriaguez o intoxicación.</li>
                                            <li>Imputaciones o condenas judiciales.</li>
                                            <li>Disputas y conflictos con familiares o personas cercanas.</li>
                                            <li>Embarazo no deseado o aborto.</li>
                                            <li>Cambios vitales bruscos no deseados.</li>
                                            <li>Efectos secundarios suicidógenos de medicaciones.</li>
                                            <li>Alta por hospitalización psiquiátrica (primera semana).</li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="seccion">
                                    <h4 className="icon-plus"><b>Adolescentes y jovenes</b></h4>
                                    <div className="secContenido">
                                        <ul>
                                            <li>Fracaso escolar. Problemas disciplinarios escolares. Presión escolar. Períodos de exámenes.</li>
                                            <li>Bullying, acoso, humillaciones, malos tratos.</li>
                                            <li>Abuso sexual. Violaciones.</li>
                                            <li>Discriminación y exclusión por la orientación sexual y/o su identidad de género.</li>
                                            <li>Separación o pérdida de amigxs y compañerxs. Cambios habituales de residencia y de entorno social.</li>
                                            <li>Desengaño amoroso.</li>
                                            <li>Muerte de un ser querido.</li>
                                            <li>Entorno suicida. Presión para cometer suicidio.</li>
                                            <li>Embarazo adolescente.</li>
                                            <li>Separación de los padres o graves conflictos conyugales, con instrumentalización del hijo. Violencia en el círculo familiar. </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="seccion">
                                    <h4 className="icon-plus"><b>Adultos</b></h4>
                                    <div className="secContenido">
                                        <ul>
                                            <li>Fracaso profesional.</li>
                                            <li>Pérdida de empleo (primer año) o dificultades económicas.</li>
                                            <li>Pérdida de estatus o prestigio social.</li>
                                            <li>Ruptura conyugal, desengaño amoroso.</li>
                                            <li>Jubilación.</li>
                                            <li>Alcoholismo.</li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="seccion">
                                    <h4 className="icon-plus"><b>Adultos mayores</b></h4>
                                    <div className="secContenido">
                                        <ul>
                                            <li>Empeoramiento de enfermedades, aumento del dolor, fracaso, hartazgo, aumento de la dependencia. Pérdida de funciones físicas o psicológicas básicas.</li>
                                            <li>Institucionalización. Etapa de adaptación a un hogar de ancianos.</li>
                                            <li>Malos tratos.</li>
                                            <li>Cambio periódico de domicilio.</li>
                                            <li>Viudez (especialmente el primer año).</li>
                                            <li>Sentimientos de soledad e inutilidad. Inactividad.</li>
                                            <li>Pérdida de interés por la vida. </li>
                                            <li>Pérdida de la fe.</li>
                                        </ul>
                                    </div>
                                </div>
                            </p>
                        </div>
                    </div>
                    <div className="seccion">
                        <h4 className="icon-plus"><b>Dimensiones Suicidológicas</b></h4>
                        <div className="secContenido">
                            <ul>
                                <li>Ideación suicidas: presencia, contenido, intensidad, frecuencia, duración.</li>
                                <li>Plan suicida: grado de planeación vinculado a cómo llevarlo a cabo.</li>
                                <li>Intento previo: presencia, método utilizado, circunstancias que rodearon el acto.</li>
                                <li>Antecedentes en la familia y/o entorno social próximo.</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="card formTextItem">
                    <h1>Señales de alerta</h1>
                    <p className="description">
                        Signos y características detectables que indicarían elevado riesgo de intento de suicidio en el tiempo próximo, es 
                        decir que pueden señalar con cierto grado de probabilidad el desenlace inminente de una crisis suicida.
                    </p>
                    <div className="seccion">
                        <h4 className="icon-plus"><b>Listado de señales de alerta más aceptados</b></h4>
                        <div className="secContenido">    
                            <ul>
                                <li>Cambios bruscos en los hábitos de comer y dormir.</li>
                                <li>Cambios repentinos en el estado de ánimo.</li>
                                <li>Falta de reacción ante frecuentes agresiones del entorno social.</li>
                                <li>Retraimiento de sus amigos, familiares o actividades habituales.</li>
                                <li>Poco interés hacia actividades que antes le resultaban divertidas o agradables.</li>
                                <li>Disminución del rendimiento en las actividades escolares o laborales.</li>
                                <li>Despreocupación por el aspecto personal.</li>
                                <li>Frecuente de desvaloración (se tiran abajo).</li>
                                <li>Fantasías de dormirse y no despertar.</li>
                                <li>Sentimientos de desesperanza y desilusión frecuentes.</li>
                                <li>Sentimientos de desesperación y culpa .</li>
                                <li>Problemas afectivos y dificultades en su comunicación.</li>
                                <li>Pérdidas recientes e importantes: afectivas o de status.</li>
                                <li>Obsesión con la muerte o pensamientos recurrentes en torno a ella.</li>
                                <li>Presencia de deseos de muerte o fantasías de autodestrucción.</li>
                                <li>Comportamiento autodestructivo. Intentos previos.</li>
                                <li>Proferir amenazas suicidas a amigos, familiares u otras personas o mediante post en las redes sociales.</li>
                                <li>Repartir objetos muy queridos.</li>
                                <li>Realización de escritos de despedida.</li>
                                <li>Organización de reuniones de despedida.</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="card formTextItem">
                    <h1 className="noDescription">A dónde ir</h1>
                    <div className="seccion">
                        <h4 className="icon-plus"><b>Listado de lugares donde asistir</b></h4>
                        <div className="secContenido">    
                            <ul>
                                <li><a href={pdf1}>
                                    ATENCIÓN DE LAS URGENCIAS EN SALUD MENTAL. Ministerio de Salud y 
                                    Desarrollo Social de la Nación. 2019
                                </a></li>
                                <li><a href={pdf2}>
                                    DISPOSITIVOS DE ATENCIÓN DE SALUD MENTAL Y ADICCIONES EN EL PARTIDO 
                                    DE GENERAL PUEYRREDON. Mesa Intersectorial de Salud Mental Comunitaria Mar del Plata. 2017
                                </a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}